var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signIn container"},[_c('h1',[_vm._v("Sign In")]),_c('UserAuth',{attrs:{"type":"signin"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }